RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.AdsInsights = window.createMarionetteApp();
    app.name = 'AdsInsights';

});
